import script from "./CustomFields.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFields.vue?vue&type=script&setup=true&lang=js"

import "./CustomFields.vue?vue&type=style&index=0&id=5c3353f2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3353f2"]])

export default __exports__